import React, { useState } from "react";
import styled from "styled-components";
import { FontSize } from "@themes/Fonts";

const ProgressWrapper = styled.div`
    display: flex;

    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    height: fit-content;
    width: 100%;

    padding: 4px 12px;
`;

const ProgressBar = styled.div<{ overrideBackgroundColor: string }>`
    height: 10px;
    width: 100%;

    background-color: ${(props) => props.overrideBackgroundColor ?? props.theme.controlPrimary};
    border-radius: 5px;
`;

const ProgressBarFill = styled.div<{ fillPercentage: number; overrideFillColor: string }>`
    height: inherit;
    width: ${(props) => props.fillPercentage || 0}%;
    transition: width 200ms ease-in-out;

    background-color: ${(props) => props.overrideFillColor ?? props.theme.controlSecondary};
    border-radius: 5px;
`;

const ProgressTextIndicator = styled.span`
    display: inline-block;
    min-width: fit-content;
    width: 36px;
    margin-left: 10px;

    color: ${(props) => props.theme.textColorPrimary};
    font-size: ${FontSize.small};

    &:hover {
        cursor: pointer;
    }
`;

interface LifeAtProgressBarProps {
    /**
     * The percentage that the progress bar should be filled.
     */
    readonly progressPercentage: number;
    /**
     * The value completed (out of the progressTotal value).
     */
    readonly progressNum?: number;
    /**
     * The max value (whole) number for the progress bar.
     */
    readonly progressTotal?: number;
    /**
     * Hide the fraction / percentage text next to progress bar
     */
    readonly hideText?: boolean;
    /**
     * Override the background color of the progress bar.
     */
    readonly overrideBackgroundHex?: string;
    /**
     * Override the fill color of the progress bar.
     */
    readonly overrideFillHex?: string;
    /**
     * Class name for styled-components to apply custom widths.
     */
    className?: string;
}
export default function LifeAtProgressBar(props: LifeAtProgressBarProps) {
    const [showPercentage, setShowPercentage] = useState(false);

    const displayData = !showPercentage
        ? `${props.progressNum || 0} / ${props.progressTotal || 0}`
        : `${props.progressPercentage.toFixed(0)}%`;

    const handleToggleDisplayData = () => {
        setShowPercentage(!showPercentage);
    };

    return (
        <ProgressWrapper className={props.className}>
            <ProgressBar overrideBackgroundColor={props.overrideBackgroundHex}>
                <ProgressBarFill fillPercentage={props.progressPercentage} overrideFillColor={props.overrideFillHex} />
            </ProgressBar>

            {!props.hideText && (
                <ProgressTextIndicator onClick={handleToggleDisplayData}>{displayData}</ProgressTextIndicator>
            )}
        </ProgressWrapper>
    );
}
